import React from 'react'
import { Cell, Checkbox, DataBlock, Divider, Grid } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdmRecordName({ individual, collectionType }) {
  const { t } = useTranslation()

  const origGivenName = individual?.names?.[1]?.givenName?.value
  const origSurname = individual?.names?.[1]?.surname?.value
  const surnameGenerated = individual?.names?.[2]?.surname?.value === 'Y'
  const origGender = individual?.sex?.value
  const nameId = individual?.permanentRecFileNumber?.value
  const currentStatus = individual?.customTags?.[0]?.value === 'Living'
  const under8 = individual?.customTags?.[1]?.value === 'Y'
  const origSource = individual?.customTags?.[3].value
  const generatedGender = individual?.customTags?.[4]?.value
  const rfn = individual?.recIdNumber?.value
  const cofRfn = individual?.familiesWhereChild?.[0]?.family?.recFileNumber?.value || ''

  return (
    <Grid>
      <Cell columns={3}>
        <DataBlock heading={t('givenName', 'Given Name')} data={origGivenName} />
      </Cell>
      <Cell columns={3}>
        <DataBlock heading={t('name.parts.surname', 'Surname')} data={origSurname} />
      </Cell>
      <Cell columns={2}>
        <DataBlock heading={t('odm.origGender', 'Original Gender')} data={origGender} />
      </Cell>
      <Cell columns={2}>
        <DataBlock heading={t('odv.nameId', 'Name ID')} data={nameId} />
      </Cell>
      <Cell columns={1}>
        <DataBlock heading={t('living', 'Living')} data={<Checkbox name="living" checked={currentStatus} readOnly />} />
      </Cell>
      <Cell columns={2}>
        <DataBlock heading={t('odm.source.original', 'Original Source')} data={origSource} />
      </Cell>
      <Cell columns={1}>
        <DataBlock heading={t('odv.collection', 'Collection')} data={collectionType} />
      </Cell>
      <Cell columns={3}>
        <DataBlock
          heading={t('odm.name.generated', 'Surname Generated From Father')}
          data={<Checkbox name="surnameGenerated" checked={surnameGenerated} readOnly />}
        />
      </Cell>
      <Cell columns={2}>
        <DataBlock heading={t('odm.generatedGender', 'Generated Gender')} data={generatedGender} />
      </Cell>
      <Cell columns={1}>
        <DataBlock heading={t('odv.rfn.', 'RFN')} data={rfn} />
      </Cell>
      <Cell columns={1}>
        <DataBlock heading={t('odm.cofRfn', 'COF RFN')} data={cofRfn} />
      </Cell>
      <Cell columns={2}>
        <DataBlock
          heading={t('odm.under8', 'Died Under The Age Of 8')}
          data={<Checkbox name="under8" checked={under8} readOnly />}
        />
      </Cell>
      <Cell columns={12}>
        <Divider />
      </Cell>
    </Grid>
  )
}
